module.exports = __webpack_public_path__ + "static/sample-billsby-743a432c5e785a91598993a4a2390bda.png";